import { assertUnreachable } from '@/Utility/Assertions/assertUnreachable';
import { t } from 'i18next';

export const STATUS = {
    Planned: 1,
    Arrived: 2,
    Started: 3,
    Completed: 4,
    Dictated: 5,
    Finished: 6,
    Correction: 8,
    Control: 9,
    Cancelled: 10,
    Transcription: 11,
} as const;

export type Status = typeof STATUS[keyof typeof STATUS];

export const getStatusAsString = (status: Status): string => {
    switch (status) {
        case STATUS.Planned:
            return t('Planned');
        case STATUS.Arrived:
            return t('Arrived');
        case STATUS.Started:
            return t('Started');
        case STATUS.Completed:
            return t('Completed');
        case STATUS.Dictated:
            return t('Dictated');
        case STATUS.Finished:
            return t('Finished');
        case STATUS.Correction:
            return t('Correction');
        case STATUS.Control:
            return t('Control');
        case STATUS.Cancelled:
            return t('Cancelled');
        case STATUS.Transcription:
            return t('Transcription');
        default:
            return assertUnreachable(status);
    }
};

export default Status;
